import React from 'react'
import { Helmet } from 'react-helmet'
import RouteMap from 'assets/RouteMap'
import DefaultHelmet from './DefaultHelmet'

class StartupsHelmet extends React.Component {
    render () {
        return <>
            <DefaultHelmet
                title="Start-ups, let's level up met een oplossing speciaal voor jullie."
                description="Bereik 500.000+ gemotiveerde studenten en young professionals doorheen heel België."
                imageCloudinaryKey='assets/startups-students'
            />
            <Helmet>
                <meta property='og:type' content='website' />
                <meta property="og:url" content={`https://www.student.be${window.location.pathname}`} />
                <link rel="canonical" href={RouteMap.Page('startups', 'nl')} />
                <link rel="alternate" hrefLang="nl-BE" href={RouteMap.Page('startups', 'nl')} />
                <link rel="alternate" hrefLang="x-default" href={RouteMap.Page('startups', 'nl')} />
            </Helmet>
        </>
    }
}

export default StartupsHelmet
